module.exports = "/_next/static/images/you_line-6bbca2a2a6c161edf2d34e176f92ecd0.jpg";